export default "/images/bike-people.png?9db15e2916677402a53e95b60059fe5d";